// Configuration de l'installeur Spotichou (affiché dans la carte projet /projects).

// Lien de téléchargement direct du fichier .apk (artefact EAS).
// À mettre à jour à chaque nouveau build ; c'est aussi la cible du QR code.
// NB: un artefact Expo peut être purgé après ~30 j sur le plan gratuit.
export const SPOTICHOU_APK_URL =
  'https://expo.dev/artifacts/eas/Egm3Z_5VSlKdINC4Mh5gaMPS71-lekuqs3Rj8ZaLyso.apk';

// Valeurs à reporter dans le tableau de bord développeur Spotify.
export const SPOTICHOU_CONFIG = {
  dashboardUrl: 'https://developer.spotify.com/dashboard',
  packageName: 'com.spotichou',
  redirectUri: 'spotichou://callback',
  sha1: '0F:F1:67:DD:98:A9:7E:2A:32:85:98:68:27:9D:26:4C:3F:EF:4C:A4',
};

// QR code généré côté serveur (même service que qrcodes/generate.sh), sans dépendance.
export const spotichouQrUrl = (size = 240) =>
  `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&margin=8&data=${encodeURIComponent(
    SPOTICHOU_APK_URL
  )}`;
